import { Link } from '@tanstack/react-router';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { useGT } from 'gt-react';
import paths from 'src/paths';
import { Button } from 'src/components/ui/button';

/**
 * "View in new tab" button for a selected email template. `templateRef` is a
 * `builtin:<key>` ref or an org template id — both are URL segments of the
 * template page, so no lookup is needed.
 */
export function TemplateLinkButton({ templateRef }: { templateRef: string }) {
  const gt = useGT();
  return (
    <Link
      to={paths.authenticated.settings.emailTemplate}
      params={{ templateId: templateRef }}
      target="_blank"
      rel="noopener noreferrer"
      className="shrink-0"
      aria-label={gt('View the selected email template', {
        context: 'aria label, opens the template page in a new tab',
      })}
      title={gt('View template', {
        context: 'tooltip, opens the email template in a new tab',
      })}
    >
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8"
        tabIndex={-1}
      >
        <ArrowSquareOutIcon className="h-4 w-4" />
      </Button>
    </Link>
  );
}
